import React from 'react';
const SvgPpsx = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M34 3H12v4H4v1h1v18h8v3h-3v1h3v3l-5 5v2l4-4v9h2v-1h3v1h27V13z" />
      <path fill="#949494" d="M44 13L34 3H12v4h1V4h20v10h10v30H17v1h27V13zm-10 0V4.5l8.5 8.5H34z" />
      <path fill="#FFF" d="M5.5 7.5h23v18h-23z" />
      <path fill="gray" d="M28 8v17H6V8h22m1-1H5v19h24V7z" />
      <path fill="gray" d="M4 7h26v1H4zM16 25h1v5h-1z" />
      <path fill="#C8C8C8" d="M8 11h2v11H8z" />
      <path fill="#F5BA9D" d="M12 13h2v9h-2z" />
      <path fill="#C8C8C8" d="M16 15h2v7h-2z" />
      <path fill="#F5BA9D" d="M20 17h2v5h-2z" />
      <path fill="#C8C8C8" d="M24 19h2v3h-2z" />
      <path fill="#D04727" d="M18 38l-5-5-5 5v2l4-4v9h2v-9l4 4z" />
      <path fill="gray" d="M10 29h13v1H10z" />
      <linearGradient id="ppsx_svg__a" gradientUnits="userSpaceOnUse" x1={38} y1={16.906} x2={38} y2={14.088}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#ppsx_svg__a)" d="M33 14h10v3H33z" />
      <linearGradient id="ppsx_svg__b" gradientUnits="userSpaceOnUse" x1={31.27} y1={12.23} x2={37.236} y2={6.264}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#ppsx_svg__b)" d="M12 3v1h21v10h10v14h1V13L34 3z" />
      <linearGradient id="ppsx_svg__c" gradientUnits="userSpaceOnUse" x1={8.201} y1={3.718} x2={41.798} y2={46.72}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#ppsx_svg__c)" d="M34 3H12v4H4v1h1v18h8v3h-3v1h3v3l-5 5v2l4-4v9h2v-1h3v1h27V13z" />
    </svg>
  );
});
export default SvgPpsx;
SvgPpsx.iconName = 'ppsx';
SvgPpsx.displayName = 'SvgPpsx';
